import { useCallback, useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { interactionModelOperations } from '../redux'
import { useAppDispatch, useAppSelector } from 'state/store'

type UrlParams = {
  id_interaction_model: string
}

type UseInteractionModelParams = {
  currentTime: string
}

const useInteractionModel = ({ currentTime }: UseInteractionModelParams) => {
  const dispatch = useAppDispatch()
  const { id_interaction_model: urlInteractionModelUuid } =
    useParams<UrlParams>()

  const interactionModel = useAppSelector((state) => state.interactionModel)

  const { error } = interactionModel

  const getInteractionModel = useCallback(() => {
    if (!urlInteractionModelUuid) {
      console.error('No interaction model ID found')
      return
    }

    dispatch(
      interactionModelOperations.getInteractionModel(urlInteractionModelUuid)
    )
  }, [dispatch, urlInteractionModelUuid])

  useEffect(() => {
    getInteractionModel()
  }, [
    getInteractionModel,
    urlInteractionModelUuid,
    interactionModel?.flatData?.uuid,
    dispatch
  ])

  useEffect(() => {
    if (interactionModel.interactionFinished) {
      dispatch(
        interactionModelOperations.setConfigToNewInteraction(currentTime)
      )
    }
  }, [interactionModel, currentTime, dispatch])

  return {
    interactionModel,
    interactionModelError: error,
    getInteractionModel,
    isFetchingInteractionModel: interactionModel?.isFetching
  }
}

export default useInteractionModel
